import * as React from "react";
import LazyLoad from "react-lazyload";

import { UitkCardAloha, UitkCardAlohaLink, UitkCardAlohaPlaceholder } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { MediaAttribution } from "components/utility/MediaAttributionUtil";

import { SimilarDestinationCardProps } from "../typings";

const SimilarDestinationCard = (props: SimilarDestinationCardProps) => {
  const { destination, destinationImageUrl } = props;
  const { media: destinationMedia, link: destinationLink, localisedRegionName: destinationLocalizedName } = destination;
  const attribution = MediaAttribution(destinationMedia, destinationLocalizedName);

  return (
    <LazyLoad offset={500} height="100%" once={true} placeholder={<UitkCardAlohaPlaceholder />}>
      <UitkCardAloha>
        <UitkCardAlohaLink>
          <TrackedLink
            moduleName="TG.LP"
            rfrr="Dest.OtherPlaces"
            href={destinationLink}
            data-testid={`similar-destinations-${destinationLocalizedName}`}
          >
            {destinationLocalizedName}
          </TrackedLink>
        </UitkCardAlohaLink>

        <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
          <UitkImage alt={attribution.attributionAltText} src={destinationImageUrl} />
          <UitkScrim className="uitk-type-heading-600">{destinationLocalizedName}</UitkScrim>
          {attribution.attributionText}
        </UitkFigure>
      </UitkCardAloha>
    </LazyLoad>
  );
};

export default SimilarDestinationCard;
